<!-- Header -->
<div class="flex-header mat-dialog-title">Add Link</div>
<!-- Body -->
<div class="flex-content">
  <form [formGroup]="addLinkForm">
    <div>
      <tyl-form-field label="Name" [errorMessage]="nameErrorMessage" style="width: 100%">
        <input formControlName="name" matInput name="Name" required maxlength="50">
      </tyl-form-field>
    </div>
    <div>
      <tyl-form-field label="URL" style="width: 100%">
        <input formControlName="url" matInput name="URL" required>
      </tyl-form-field>
    </div>
    <div *ngIf="V10">
      <tyl-checkbox [(checked)]="usingHttps" name="Open using HTTPS">Open using HTTPS</tyl-checkbox>
    </div>
  </form>
</div>
<!-- Footer -->
<div class="flex-footer">
  <div class="flex-footer-right">
    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()" translate></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancelClick()" translate></tyl-button>
  </div>
</div>

